import { render, staticRenderFns } from "./multiRewardModal.vue?vue&type=template&id=6321bef8&scoped=true"
import script from "./multiRewardModal.vue?vue&type=script&lang=js"
export * from "./multiRewardModal.vue?vue&type=script&lang=js"
import style0 from "./multiRewardModal.vue?vue&type=style&index=0&id=6321bef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6321bef8",
  null
  
)

export default component.exports